import { createRouter, createMemoryHistory, createWebHistory, createWebHashHistory } from 'vue-router'
import { App } from '@capacitor/app';
import routes from './routes'

export default function ({ store }) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : process.env.VUE_ROUTER_MODE === 'history' ? createWebHistory : createWebHashHistory

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes: routes(store),

    history: createHistory(process.env.MODE === 'ssr' ? void 0 : process.env.VUE_ROUTER_BASE)
  })

  App.addListener('appUrlOpen', function (event) {
    const slug = event.url.split('.app').pop();

    if (slug) {
      router.push({
        path: slug,
      });
    }
  });

  return Router
}
